<div [ngClass]="{'loading': loading}">
  <app-spinner [name]="'ticketingReservations'" [(show)]="loading"></app-spinner>
</div>

<div class="esf-accordion esf-accordion--info-tiles" *ngIf="!loading">
  <div *ngFor="let invoiceByYear of invoiceList" class="esf-info-tile-grid__item" style="display: flex; flex-direction: column;">

    <div class="esf-accordion__unit">
      <div class="esf-accordion__trigger" [ngClass]="{'-is-open': invoiceByYear.opened}" (click)="invoiceByYear.opened = !invoiceByYear.opened">
        <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level">
          <span class="esf-action-heading__text">{{ invoiceByYear.year }}</span>
        </h4>
      </div>
      <div class="esf-accordion__target" [ngClass]="{'no-display': !invoiceByYear.opened}">

        <div class="esf-info-tile esf-info-tile--full-width">
          <div class="esf-info-tile__content">
            <table class="esf-table"
                   *ngIf="invoiceByYear.invoiceTickets?.length"
                   app-table
                   [columns]="columns"
                   [keys]="keys"
                   [data]="invoiceByYear.invoiceTickets"
                   (rowClickEvent)="openInvoice($event)">
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <table class="esf-table" *ngIf="!invoiceList?.length">
    <section class="esf-empty-state"
             *ngIf="!invoiceList?.length"
             app-empty-state
             [emptyStateIcon]="'#esf-icon-ticket'"
             [emptyStateText]="tixxReservationsTimedOut ? tablesTranslations.i18nTooManyReservations : tablesTranslations.i18nNoReservations">
    </section>
  </table>
</div>
